<div *ngIf="loggedIn">
  <p class="navbar-text">Signed in as {{username}}</p>
  <button type="button" class="btn btn-default navbar-btn" (click)="logout()">Sign Out</button>
</div>
<div *ngIf="!loggedIn">
  <p class="navbar-text">You are currently logged out</p>
  <button type="button" class="btn btn-default navbar-btn" (click)="login()">Sign In</button>
</div>
